export default __webpack_public_path__ + "static/cafe_36077-28d1ffa04d0cda89893cafaf21839017.png";